const menuEnLang = {
  // admin menu
  'menu.MainMenu': 'Main Menu',
  'menu.SystemSettings': 'System Settings',
  'menu.Dashboard': 'Dashboard',
  'menu.CountryRegionCity': 'Countries, Regions, Cities',
  'menu.Regions': 'Regions',
  'menu.Countries': 'Countries',
  'menu.Cities': 'Cities',
  'menu.Emails': 'Emails',
  'menu.EmailTemplates': 'Email Templates',
  'menu.AdminUsers': 'Admin users',
  'menu.AccessControl': 'Access control',
  'menu.Partners': 'Partners',
  'menu.Companies': 'Companies',
  'menu.Passengers': 'Passengers',
  'menu.Services': 'Services',
  'menu.Plans': 'Plans',
  'menu.SoftwareComponents': 'Software components',
  'menu.Tariffs': 'Tariffs',
  'menu.Staffs': 'Staffs',
  'menu.Notifications': 'Notifications',
  'menu.Stations': 'Stations',
  'menu.Discounts': 'Discounts',
  'menu.CompanySettings': 'Company settings',
  'menu.Subscriptions': 'Subscriptions',
  'menu.Fleets': 'Fleets',
  'menu.SeatModels': 'Seat models',
  'menu.TicketClasses': 'Ticket classes',
  'menu.Buses': 'Buses',
  'menu.BusModels': 'Bus models',
  'menu.Templates': 'Templates',
  'menu.SmsTemplates': 'Sms Templates',
  'menu.RoutesAndTrips': 'Routes and trips',
  'menu.Routes': 'Routes',
  'menu.TicketTariffs': 'Ticket Tariffs',
  'menu.BaggageTariffs': 'Baggage Tariffs',
  'menu.Trips': 'Trips',
  'menu.TripsCalendar': 'Trips calendar',
  'menu.TripDetails': 'Trip details',
  'menu.Registers': 'Registers',
  'menu.Terminals': 'Terminals',
  'menu.Tickets': 'Tickets',
  'menu.PdfTemplates': 'Pdf Templates',
  'menu.Bookings': 'Bookings',
  'menu.TicketConflict': 'Ticket conflict',
  'menu.TariffAgeIssues': 'Sales to review',
  'menu.ControlReviews': 'Controls to review',
  'menu.CreditNotes': 'Credit notes',
  'menu.Roles': 'Roles',
  'menu.SellOnTheGoBookings': 'Sell on the go bookings',
  'menu.PassengerAppSettings': 'Passenger App Settings',
  'menu.Settings': 'Settings',
  'menu.CompanyRoles': 'Company Roles',
  'menu.Reports': 'Reports',
  'menu.TripStatusReport': 'Trip status',
  'menu.CommonSetting': 'Common settings',
  'menu.SalesReport': 'Sales Report',
  'menu.TripsReport': 'Trips Report',
  'menu.TripDetailReport': 'Trip Details Report',
  'menu.TripIncomeReport': 'Trip Income Report',
  'menu.UnEarnedRevenueReport': 'Un Earned Report',
  'menu.SaleWithGroupReport': 'Sale With Group Report',
  'menu.Advertising': 'Advertising',
  'menu.SellOnTheGoReconciliation': 'Sell on the go reconciliations',
  'menu.PassengerAppUsers': 'Passengers',
  'menu.BaggageReconciliations': 'Baggage Reconciliations',
  'menu.ShipmentManagement': 'Shipment Management',
};
export default menuEnLang;
